import classes from "./MessageCard.module.css";
import PropTypes from "prop-types";
import { Button } from "@mui/material";

const MessageCard = (props) => {
  return (
    <div className={classes.messageContent}>
      <img src={props.icon} />
      <span className={classes.title}>{props.title}</span>
      <p className={classes.text}>{props.text}</p>
      <Button onClick={props.clickHandler}>{props.buttonText}</Button>
    </div>
  );
};

MessageCard.propTypes = {
  messageContent: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  buttonText: PropTypes.string,
  clickHandler: PropTypes.func,
};

export default MessageCard;
